import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
// import { useMount } from 'react-use';
import * as S from './style';
import { useStore } from '../../contexts/MapContext';
import infos from '../../constants/infos';

const maps = window.naver.maps;

const drawStores = async (map, stores) => {
  stores.forEach(store => {
    let markers = [];
    let infoWindows = [];
    let getClickHandler;
    const { remain_stat, addr, lat, lng, name, stock_at, created_at } = store;
    const animation =
      remain_stat === 'empty' ||
      remain_stat === null ||
      remain_stat === undefined ||
      remain_stat === 'break'
        ? null
        : maps.Animation.BOUNCE;
    // empty, few, some, plenty
    const url =
      remain_stat === null ||
      remain_stat === undefined ||
      remain_stat === 'break'
        ? `./img/empty.png`
        : `./img/${remain_stat}.png`;
    const marker = new maps.Marker({
      position: maps.LatLng(lat, lng),
      map,
      icon: {
        url,
        size: new maps.Size(48, 36),
        origin: new maps.Point(0, 0)
      },
      animation
    });
    switch (remain_stat) {
      case 'plenty':
        marker.zIndex = 4000;
        break;
      case 'some':
        marker.zIndex = 3000;
        break;
      case 'few':
        marker.zIndex = 2000;
        break;
      default:
        marker.zIndex = 1000;
    }
    console.log(marker);
    markers.push(marker);
    const infoWindow = new maps.InfoWindow({
      content: `
    <div class="info" style="width:300px;padding:20px;">
      <div class="row">
        <div class="col header">장소</div>
        <div class="col">${name}</div>
      </div>
      <div class="row">
        <div class="col header">주소</div>
        <div class="col">${addr}</div></div>
      <div class="row">
      <div class="col header">최종입고 시간</div>
        <div class="col">${stock_at !== null ? stock_at : '정보 없음'}</div>
      </div>
      <div class="row">
        <div class="col header">업데이트 시간</div>
        <div class="col">${created_at !== null ? created_at : '정보 없음'}</div>
      </div>
      <div class="row">
        <div class="col header">재고</div>
        <div class="col">${
          infos[
            remain_stat === null ||
            remain_stat === undefined ||
            remain_stat === 'break'
              ? 'empty'
              : remain_stat
          ].description
        }</div>
      </div>
    </div>
    `
    });
    infoWindows.push(infoWindow);
    getClickHandler = () => {
      if (infoWindow.getMap()) {
        infoWindow.close();
      } else {
        infoWindow.open(map, marker);
      }
    };
    maps.Event.addListener(marker, 'click', getClickHandler);
  });
};
const Map = observer(() => {
  const [map, setMap] = useState(null);
  const [, setMarker] = useState(null);
  const {
    location,
    stores,
    getStores,
    setOpenModal,
    setIsLoading
  } = useStore();

  useEffect(() => {
    const mapOptions = {
      center: new maps.LatLng(37.3595704, 127.105399),
      zoom: 15
    };
    const tempMap = new maps.Map('map', mapOptions);

    setMarker(
      new maps.Marker({
        position: maps.LatLng(37.3595704, 127.105399),
        map: tempMap,
        animation: maps.Animation.DROP
      })
    );
    setMap(tempMap);
  }, []);

  useEffect(() => {
    if (location[0] === 37.3595704 && location[1] === 127.105399) return;
    if (location[0] === undefined || location[1] === undefined) return;
    const newCenter = new maps.LatLng(...location);
    map.setCenter(newCenter);
    setMarker(
      new maps.Marker({
        position: maps.LatLng(...location),
        map
        // animation: maps.Animation.BOUNCE
      })
    );
    getStores();
  }, [location, map, getStores]);

  useEffect(() => {
    if (stores.length === 0) return;
    drawStores(map, stores).then(() => {
      setOpenModal(false);
      setIsLoading(false);
    });
  }, [stores, map, setOpenModal, setIsLoading]);

  return <S.MapContainer id='map' />;
});

export default Map;
